import { useUserPermData } from '../../utils/user-perm-context';

import { AdminOnboardingPage } from './admin';
import { UserOnboardingPage } from './user';

export const OnboardingPage = () => {
	// NOTE: This is temporary permission switch, we might likely to update this to site permissions in the future
	const { rovoDevAgentsUser } = useUserPermData();

	if (!rovoDevAgentsUser.isAdmin) {
		return <UserOnboardingPage />;
	}

	return <AdminOnboardingPage />;
};
